import AxiosConfig from '@/config/axios-config'

export const EmpresaAPI = {

  pegaConfiguracaoWL (subdominio) {
    return AxiosConfig.jalekoAPI().get(`empresas/configuracoes-wls/${subdominio}`).then(response => response.data)
  }

}

export default EmpresaAPI
